import { fromPairs, get } from 'lodash';
import {
  GAIN_SETTINGS,
  AGC_GAIN_CAPS_PREFIX,
  OSC_MIT_GAIN_PREFIX,
  AGC_DURATION_PREFIX,
  networkElements,
  agcGainCapsPropNames,
  oscMitGainsPropNames,
  agcDurationPropNames
} from './constants';

export function hasNetworkElement(properties, networkElement) {
  return get(properties, `${networkElement}.provision-info.expected-serial-id`, '').length >= 20;
}

export function getAgcGainCaps(networkElement, prevProps, nextProps) {
  return getChangedGainSettings(networkElement, AGC_GAIN_CAPS_PREFIX, agcGainCapsPropNames, prevProps, nextProps);
}

export function getOscMitGains(prevProps, nextProps) {
  return getChangedGainSettings(networkElements[0], OSC_MIT_GAIN_PREFIX, oscMitGainsPropNames, prevProps, nextProps);
}

export function getAgcDuration(prevProps, nextProps) {
  return getChangedGainSettings(networkElements[0], AGC_DURATION_PREFIX, agcDurationPropNames, prevProps, nextProps);
}

function getChangedGainSettings(networkElement, prefix, names, prevProps, nextProps) {
  const prevGainSettings = get(prevProps, [networkElement, GAIN_SETTINGS], {});
  const nextGainSettings = get(nextProps, [networkElement, GAIN_SETTINGS], {});
  const changes = names.reduce((acc, name) => {
    const key = [prefix, name].join('-');
    const nextValue = nextGainSettings[key];
    const prevValue = prevGainSettings[key];

    if (nextValue != null && nextValue !== prevValue) {
      acc.push([name, nextValue]);
    }

    return acc;
  }, []);

  return changes.length > 0 ? fromPairs(changes) : null;
}
